interface CircularImageProps {
  imgUrl: string;
}

const CircularImage: React.FC<CircularImageProps> = ({ imgUrl }) => {
  const styles = {
    width: '130px',
    height: '130px',
    borderRadius: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundColor: 'hsl(220, 1%, 98%)',
  };

  return <div style={{ backgroundImage: `url(${imgUrl})`, ...styles }} />;
};

export default CircularImage;
